import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContDatatoggle, Row, Column, ContentContainer, Icon, Text } from './DataToggle.styles';
import UserOnboardHover from '../../assets/images/Icons-datatoggle/onboarding-hover.webp';
import IcoAnalisisHover from '../../assets/images/Icons-datatoggle/icon-analisis-hover.webp';
import IcoPayServcesHover from '../../assets/images/Icons-datatoggle/ico-payservices-hover.webp';
import IcoAutomHover from '../../assets/images/Icons-datatoggle/icon-autom-hover.webp';
import IcoDispersionHover from '../../assets/images/Icons-datatoggle/icon-dispersion-hover.webp';
import IcoMoneyHover from '../../assets/images/Icons-datatoggle/ico-money-hover.webp';
import IcoCCHover from '../../assets/images/Icons-datatoggle/ico-credit-card-hover.webp';
import IcoNotiHover from '../../assets/images/Icons-datatoggle/ico-noti-hover.webp';
import IcoSecurityHover from '../../assets/images/Icons-datatoggle/ico-security-hover.webp';
import IcoScoringHover from '../../assets/images/Icons-datatoggle/ico-scoring-hover.webp';

const Datatoggle = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isEnglish = i18n.language === 'en';

  const serviceRoutes = {
    onboarding: isEnglish ? '/en/onboarding' : '/onboarding',
    creditAnalysis: isEnglish ? '/en/credit-analysis' : '/analisis-crediticio',
    pld: isEnglish ? '/en/anti-money-laundering' : '/pld',
    cardIssuance: isEnglish ? '/en/card-issuance' : '/emision-tarjetas',
    dispersion: isEnglish ? '/en/payment-dispersion' : '/dispersion-pagos',
    notifications: isEnglish ? '/en/notifications' : '/notificaciones',
    collections: isEnglish ? '/en/collections' : '/cobranza',
    payServices: isEnglish ? '/en/pay-services' : '/pago-servicios',
    scoring: isEnglish ? '/en/alternative-scoring' : '/score-alternativo',
    deviceLock: isEnglish ? '/en/device-lock' : '/bloqueo-dispositivos',
  };

  const handleNavigate = (route) => {
    navigate(route);
  };

  return (
    <ContDatatoggle id={'ContDatatoggle'}>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.onboarding)}>
          <ContentContainer>
            <Icon>
              <img src={UserOnboardHover} alt={'UserOnboard'} />
            </Icon>
            <Text>{t('Onboarding Digital')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.pld)}>
          <ContentContainer>
            <Icon>
              <img src={IcoSecurityHover} alt={'IcoSecurity'} />
            </Icon>
            <Text>PLD</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.creditAnalysis)}>
          <ContentContainer>
            <Icon>
              <img src={IcoAnalisisHover} alt={'IcoAnalisis'} />
            </Icon>
            <Text>{t('Análisis Crediticio')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.cardIssuance)}>
          <ContentContainer>
            <Icon>
              <img src={IcoCCHover} alt={'IcoCC'} />
            </Icon>
            <Text>{t('Emisión de tarjetas')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.dispersion)}>
          <ContentContainer>
            <Icon>
              <img src={IcoDispersionHover} alt={'IcoDispersion'} />
            </Icon>
            <Text>{t('Dispersión')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.notifications)}>
          <ContentContainer>
            <Icon>
              <img src={IcoNotiHover} alt={'IcoNoti'} />
            </Icon>
            <Text>{t('Campaña de notificaciones')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.collections)}>
          <ContentContainer>
            <Icon>
              <img src={IcoMoneyHover} alt={'IcoMoney'} />
            </Icon>
            <Text>{t('Cobranza')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.payServices)}>
          <ContentContainer>
            <Icon>
              <img src={IcoPayServcesHover} alt={'IcoPayServces'} />
            </Icon>
            <Text>{t('Pago de servicios')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.scoring)}>
          <ContentContainer>
            <Icon>
              <img src={IcoScoringHover} alt={'IcoScoring'} />
            </Icon>
            <Text>{t('Score alternativo')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.deviceLock)}>
          <ContentContainer>
            <Icon>
              <img src={IcoAutomHover} alt={'IcoAutom'} />
            </Icon>
            <Text>{t('Candado de Smartphones')}</Text>
          </ContentContainer>
        </Column>
      </Row>
    </ContDatatoggle>
  );
};

export default Datatoggle;
